export default {
	computed: {
		payment_methods() {
			return [
	            {
	                "id_medio_pago": "1",
	                "descripcion": "Visa",
	            }, 
	            {
	                "id_medio_pago": "31",
	                "descripcion": "Visa Débito",
	            }, 
	            {
	                "id_medio_pago": "114",
	                "descripcion": "Visa Prepaga",
	            }, 

	            {
	                "id_medio_pago": "15",
	                "descripcion": "MasterCard",
	            }, 
				{
	                "id_medio_pago": "118",
	                "descripcion": "MasterCard Fiserv",
	            },

	            {
	                "id_medio_pago": "99",
	                "descripcion": "Maestro",
	            }, 
	            {
	                "id_medio_pago": "116",
	                "descripcion": "Master Prepaga",
	            },  

	            {
	                "id_medio_pago": "65",
	                "descripcion": "Amex",
	            }, 

	            {
	                "id_medio_pago": "23",
	                "descripcion": "Tarjeta Shopping",
	            }, 
	            {
	                "id_medio_pago": "24",
	                "descripcion": "Tarjeta Naranja",
	            }, 

	            {
	                "id_medio_pago": "27",
	                "descripcion": "Cabal",
	            }, 
	            {
	                "id_medio_pago": "120",
	                "descripcion": "Cabal Fiserv",
	            }, 

	            {
	                "id_medio_pago": "22",
	                "descripcion": "Travelpass",
	            }, 
	            {
	                "id_medio_pago": "39",
	                "descripcion": "Tarjeta Nevada",
	            }, 
	            {
	                "id_medio_pago": "43",
	                "descripcion": "Tarjeta Cencosud",
	            }, 
	            
	            {
	                "id_medio_pago": "55",
	                "descripcion": "Patagonia 365",
	            }, 

	            {
	                "id_medio_pago": "115",
	                "descripcion": "Consumax",
	            }, 
	            {
	                "id_medio_pago": "135",
	                "descripcion": "Diners Fiserv",
	            }, 
	            {
	                "id_medio_pago": "8",
	                "descripcion": "Diners",
	            }, 
			]
		}
	}
}